export default "__VITE_ASSET__Dwn0haiP__"